import clsx from "clsx";
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import { ITabSwitch } from "models/Form";
import styles from "./style.module.scss";

interface IProps {
  options: ITabSwitch[];
}

export default function TabSwitch({ options }: Readonly<IProps>) {
  const [pageType, setPageType] = React.useState<ITabSwitch>();
  const { pathname } = useLocation();

  useEffect(() => {
    const selectedTab = options.find(({ link }) => pathname.includes(link));
    setPageType(selectedTab);
  }, [options, pathname]);

  return (
    <ul className={styles.tabSwitchWrapper}>
      {options.map((item) => (
        <Link
          className={clsx(styles.tabItem, { "!text-white": pageType?.value === item.value })}
          key={item.value}
          to={item.link}
          onClick={() => setPageType(item)}>
          {item.label}
        </Link>
      ))}
      <div
        className={clsx(
          styles.tabIndicator,
          pageType?.value === options[0].value ? "translate-x-0" : "translate-x-full"
        )}></div>
    </ul>
  );
}
